import React from "react";

// Import Redux
import { currencyTransform } from "../../../providers/Redux/Reducers/reducers2";

// Import Ionic
import { IonCard, IonCardContent, IonCol, IonRow } from "@ionic/react";
import { useTranslation } from "react-i18next";

interface ITotalPrice {
  subtotal: number;
  total: number;
  discount: number;
}
// calculation result
const TotalPrice: React.FC<ITotalPrice> = ({ subtotal, total, discount }) => {
  const { t } = useTranslation();
  return (
    <IonCard>
      <IonCardContent className="ion-padding">
        <IonRow>
          <IonCol size="6" sizeLg={"7"}>
            {t("SubTotal")}
          </IonCol>
          <IonCol size="6" sizeLg={"5"} class="ion-text-right">
            {currencyTransform(subtotal)}
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="6">{t("Discount")}</IonCol>
          <IonCol size="6" class="ion-text-right">
            {currencyTransform(discount)}
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="6">{t("Total")}</IonCol>
          <IonCol size="6" class="ion-text-right">
            {currencyTransform(total)}
          </IonCol>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};

export default TotalPrice;
